/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-29 18:10:26
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-04 17:44:21
 * @FilePath: /unifyxp-v2-store-portal/src/layout/EditorPageLayout/SectionContent/index.tsx
 */
import React from 'react';

import { SectionContainer } from 'src/components/Layouts';

const SectionContent = (props) => {
  const { children, hasBottomBorder, ...rest } = props;
  return (
    <SectionContainer bottomBorder={hasBottomBorder} {...rest}>
      {children}
    </SectionContainer>
  );
};
export default SectionContent;
